import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appDisableOnClick]'
})
export class DisableOnClickDirective {
  constructor(private elementRef: ElementRef) {}

  @HostListener('click')
  onClick() {
    const button = this.elementRef.nativeElement as HTMLButtonElement;
    if (button) {
      button.disabled = true;
      console.error('Button element found');
      setTimeout(() => {
        button.disabled = false;
      }, 2000); // Adjust as needed
    } else {
      console.error('Button element not found');
    }
  }
}
